<template lang="pug">
  .menuBtn
    v-menu.theMenu(open-on-hover :bottom="fromMenu" :offset-y="fromMenu" :right="fromDrawer" :offset-x="fromDrawer")
      template(v-slot:activator='{ on }')
        v-btn.noCursor(v-on="on",text :class="{'v-btn--active': isActive}" ) About
          
      v-list.theList(color="#3C8C40",dark )
        v-list-item(v-for='(item, index) in items' :key='index' :to="item.path" @click="updateRootPage")
          v-list-item-title {{ item.title }}
</template>
<script>
export default {
  props: ['fromDrawer', 'fromMenu'],
  data: () => ({
    // isActive: false,
    items: [
      { title: 'Our Story', path: '/about/cor_ucc' },
      { title: 'Biship Flunder', path: '/about/cor_bishop' },
      { title: 'Our Staff', path: '/about/cor_staff' },
      { title: 'Our Partners', path: '/about/cor_partners' }
    ]
  }),
  methods: {
    updateRootPage() {
      this.$store.commit('setRoot', 'about');
    }
  },
  computed: {
    isActive() {
      let theRoot = this.$store.getters.getRoot;
      console.log('TCL: isActive -> theRoot', theRoot);
      return theRoot == 'about' ? true : false;
    }
    // fromMenu() {
    //   let hold = this.menu;
    //   return hold;
    // }
    // fromDrawer() {
    //   let hold = this.drawer;
    //   return hold;
    // }
  }
};
</script>
<style lang="stylus">
.noCursor
  cursor default !important
</style>
